function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import { crop as cropFn, get as getFn, notify as notifyFn, create as createFn, upload as uploadFn } from "../../services/image-service";
import ImageUploadPresentation from "./Presentation";
var ImageUpload = function(props) {
    return /*#__PURE__*/ React.createElement(ImageUploadPresentation, _extends({}, props, {
        cropFn: cropFn,
        getFn: getFn,
        notifyFn: notifyFn,
        createFn: createFn,
        uploadFn: uploadFn
    }));
};
export default ImageUpload;
